import React, { useState } from 'react';
import { SvgIcon } from '@common/sprites';
import LoyaltyDownloadAppPopup from './download_app_popup';
import classes from './loyalty_section.module.scss';

interface LoyaltySectionProps {
  t: (key: string) => string;
  progress?: User.LoyaltyProgress;
  content?: HomePage.Content;
}

function LoyaltySection({
  t, progress, content
}: LoyaltySectionProps) {
  if (!content) return null;

  const [showDownloadAppPopup, setShowDownloadAppPopup] = useState(false);
  const isLoggedIn = typeof window !== 'undefined' && window.currentUserId;
  const currentSpent = progress?.currentAmount ?? 0;
  const targetAmount = progress?.targetAmount ?? 100;
  const progressPercentage = isLoggedIn ? Math.min((currentSpent / targetAmount) * 100, 100) : 0;
  const handleSectionClick = () => {
    setShowDownloadAppPopup(!!isLoggedIn);
  };

  const handleSectionKeyDown = (e: React.KeyboardEvent) => {
    if (isLoggedIn && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      setShowDownloadAppPopup(true);
    }
  };

  return (
    <>
      <div
        className={ classes.sectionContainer }
        data-testid="HP-loyalty-section"
        onClick={ handleSectionClick }
        onKeyDown={ handleSectionKeyDown }
        role="button"
        tabIndex={ 0 }
        style={ { cursor: isLoggedIn ? 'pointer' : 'default' } }
      >
        <div className={ classes.bannerContainer }>
          <div className={ classes.iconContainer }>
            <SvgIcon id="loyalty_star_icon" size={ 48 } className={ classes.starIcon } />
          </div>
          <div className={ classes.contentContainer }>
            {isLoggedIn ? (
              <div className={ classes.loggedInContent }>
                <div className={ classes.title }>
                  { content?.title }
                </div>
                <div className={ classes.progressBarContainer }>
                  <div className={ classes.progressBar }>
                    <div
                      className={ classes.progressBarFill }
                      style={ { width: `${ progressPercentage }%` } }
                    >
                      {progressPercentage > 0 && (
                      <div className={ classes.progressIndicator }>
                        <div className={ classes.progressBubble }>
                          $
                          { currentSpent }
                        </div>
                      </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className={ classes.progressLabels }>
                  <div className={ classes.progressLabelContainer }>
                    <div className={ classes.progressLabel }>
                      $0
                    </div>
                  </div>
                  <div className={ classes.progressLabel }>
                    $
                    { targetAmount }
                  </div>
                </div>
                <div className={ classes.viewProgressLink }>
                  { progress?.currentAmount > 0 ? t('home.loyalty_section_progress_details') : t('home.loyalty_section_details') }
                </div>
              </div>
            ) : (
              <>
                <div className={ classes.title }>
                  { content?.title }
                </div>
                <div className={ classes.description }>
                  { content?.subtitle }
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <LoyaltyDownloadAppPopup
        visible={ showDownloadAppPopup }
        onClose={ () => setShowDownloadAppPopup(false) }
      />
    </>
  );
}

export default LoyaltySection;
